import { AppThunk } from '../../../store/rootReducer';
import { ecgIdSelector } from '../../ecg/selectors/ecg.selectors';
import * as clusterActions from '../actions/cluster.actions';
import { createChildren, reclassify } from '../client/cluster.client';
import { getServerCode } from '../client/helpers';
import { projectedBaseClusterSelector } from '../selectors/cluster.selectors';
import { cleanBeats } from './clean-beats.thunk';
import * as beatsActions from '../../beats/beats.actions';
import { getGroupedBeatsSelector } from '../../beats/beats.selector';

export const splitClusters = (): AppThunk => async (dispatch, getState) => {
  const ecgId = ecgIdSelector(getState());
  const selectedCluster = projectedBaseClusterSelector(getState());
  const serverBeats = getGroupedBeatsSelector(getState());
  if (ecgId == null || selectedCluster == null || serverBeats == null) {
    return;
  }
  const { selected, unselected } = serverBeats;
  const children = await createChildren(
    ecgId,
    selectedCluster,
    selected,
    unselected,
  );
  if (children == null) {
    return;
  }
  const { cluster1, cluster2 } = children;
  let reclassifiedCluster1 = cluster1;
  let reclassifiedCluster2 = cluster2;

  // when splitting clusters we must reclassify them as unclassified
  if (cluster1.classification !== 'Unclassified') {
    const unselectedClusterId = await reclassify(
      ecgId,
      [cluster1.id],
      getServerCode('Unclassified'),
    );
    const selectedClusterId = await reclassify(
      ecgId,
      [cluster2.id],
      getServerCode('Unclassified'),
    );
    if (unselectedClusterId == null || selectedClusterId == null) {
      return;
    }
    reclassifiedCluster1 = {
      ...cluster1,
      id: unselectedClusterId[0],
      classification: 'Unclassified',
    };
    reclassifiedCluster2 = {
      ...cluster2,
      id: selectedClusterId[0],
      classification: 'Unclassified',
    };
  }
  dispatch(cleanBeats());
  dispatch(beatsActions.load({ beats: reclassifiedCluster1.beats }));
  dispatch(
    clusterActions.replaceClusters({
      newClusters: [reclassifiedCluster1, reclassifiedCluster2],
      oldClusters: [selectedCluster],
    }),
  );
};
